import React, {Component} from 'react';

const POSSIBLE_COLORS = [
  '#E96224',
  '#F1C434',
  '#39AC49',
  '#286DAF',
  '#D15A1D',
  '#333333'
];

// const POSSIBLE_TEXT_COLORS = [];

class Avatar extends Component {
  render(){
    const {imageUrl,userName} = this.props,
      usernameFirstLetter = userName ? userName[0] : 'p',
      avatarColor = POSSIBLE_COLORS[usernameFirstLetter.charCodeAt(0) % 6];

    if(imageUrl){
      return (
        <img
          className='Avatar'
          src={imageUrl}
          alt='Face of user'
          style={{
            backgroundColor:avatarColor
          }}
        />
      )
    }

    return (
      <div
        className='Avatar'
        style={{
          backgroundColor:avatarColor
        }}
      >
        {usernameFirstLetter.toUpperCase()}
      </div>
    )
  }
}

export default Avatar;



// WEBPACK FOOTER //
// ./src/shared/components/Avatar/Avatar.js